module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Angle-double-down-a1327cfc8ec07e1cf0e69d9933c7e7f2.svg";